/**
 * Global Regular Expression Dictionary
 * * Centralized source of truth for all input validation and pattern matching logic.
 * Ensures consistent data integrity across the application's authentication and organization modules.
 */

export const REGEX = {
    /** * Email Validation Pattern:
     * Restricts email to @softknack.com domain only.
     * (e.g., a.name@softknack.com) - Case-insensitive.
     */
    EMAIL: /^[A-Z\d._%+-]+@[A-Z\d.-]+\.[A-Z]{2,}$/i,

    /** * Name Validation:
     * Restricts input to alphabetic characters and spaces only.
     * Prevents numeric or special character injection in personnel records.
     */
    NAME: /^[A-Za-z ]+$/,

    /** * Organization Schema:
     * Permits alphanumeric characters, underscores, and spaces.
     * Designed to accommodate institutional titles and branch designations.
     */
    ORG: /^[A-Za-z0-9_ ]+$/,

    /** * Mobile Telephony:
     * Enforces a strict numeric-only input for telephone fields.
     * Note: Country code prefixing is handled by a separate dedicated component.
     */
    MOBILE: /^\d+$/,

    /** * GSTIN:
     * 15-character Indian GSTIN (e.g. 33AABCU9603R1ZM). Mirrors the CRM and
     * Billing API regexes so a bad value is caught before the round trip.
     */
    GSTIN: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/,

    /* ---------------- PASSWORD STRENGTH CONSTRAINTS ---------------- */
    // These atomic rules are aggregated to determine overall credential entropy.

    // CAPITAL: Requires at least one uppercase character (A-Z)
    CAPITAL: /[A-Z]/,

    // LOWERCASE: Requires at least one lowercase character (a-z)
    LOWERCASE: /[a-z]/,

    // NUMBER: Requires at least one numeric digit (0-9)
    NUMBER: /\d/,

    /** * SPECIAL CHARACTER: 
     * Requires at least one non-alphanumeric character.
     * (e.g., !, @, #, $, %, etc.)
     */
    SPECIAL: /[^A-Za-z0-9]/,
};